import { FC, ReactNode, useMemo } from "react";
import { ImageUploadUpdater, ImageUploadUpdaterContext } from "../../../contexts/ImageUploadUpdaterContext";

export const ImageUploadUpdaterProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const updater = useMemo(() => new ImageUploadUpdater(), []);

    return (
        <ImageUploadUpdaterContext.Provider value={updater}>
            {children}
        </ImageUploadUpdaterContext.Provider>
    );
};